import { createApp } from 'vue'
import { createGtm } from '@gtm-support/vue-gtm'
import { createPinia } from 'pinia'
import ObserveVisibility from 'vue-observe-visibility'

import App from './App.vue'
import { router } from './router/router'
import directives from '@/directives'

// Local dev only (vite serve: import.meta.env.DEV): the site's own tracking (standardMicrositeTrackingEvent, every
// page) in the console as it is pushed to the dataLayer - not GTM's, OneTrust's or the GNB's other events. Read from
// the array as it grows, not by wrapping its push: GTM and arena-sid.js put their own push on it (async, in no fixed
// order with the app), so the log stays out of their chain. The builds (test / pre / live) leave it out.
if (import.meta.env.DEV) {
  let list = null
  let seen = 0
  const flush = () => {
    if (window.dataLayer !== list) [list, seen] = [window.dataLayer, 0]
    for (; list && seen < list.length; seen++) {
      const item = list[seen]
      if (item?.event !== 'standardMicrositeTrackingEvent') continue
      const { interaction, micrositeSectionNumber: number, micrositeSectionName: name } = item
      const label = [interaction, `${number} ${name}`, item.micrositeSectionContent]
      console.log(`[tracking] ${label.filter(Boolean).join(' · ')}`, item)
    }
  }
  flush()
  setInterval(flush, 100)
  window.addEventListener('pagehide', flush)
}

createApp(App)
  .use(createPinia())
  .use(router)
  .use(
    // https://www.npmjs.com/package/@gtm-support/vue-gtm
    createGtm({
      id: import.meta.env.VITE_GTM_ID,
      enabled: import.meta.env.NODE_ENV === 'production',
      debug: import.meta.env.NODE_ENV !== 'production',
      loadScript: false,
    })
  )
  .use(directives)
  .use(ObserveVisibility)
  .mount('#app')

// import { createApp } from 'vue'
// import Person from './Person.vue'
// createApp(Person).mount('#app')
